export default "__VITE_ASSET__DBL7TF7C__"